import api from './index'

const resource = 'publication_attachments'

export default {
  getPublicationAttachment (id) {
    return api.get(`${resource}/${id}/download_attachment`, { responseType: 'arraybuffer' })
  }
}
